import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { SEOService } from '../../services';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  standalone: true,
})
export class TermsComponent {
  private seoService = inject(SEOService);
  private domSanitizer = inject(DomSanitizer);

  public matomoIframeUrl: SafeResourceUrl[] = [];

  constructor() {
    this.seoService.updateTitle('Mentions Légales - Reelax Tickets');
    environment.matomo.trackers.forEach((tracker) => {
      this.matomoIframeUrl.push(this.domSanitizer.bypassSecurityTrustResourceUrl(tracker.trackerUrl + '/index.php?module=CoreAdminHome&action=optOut&language=fr&backgroundColor=F4F4F4&fontColor=242425&fontSize=14px&fontFamily=Open%20Sans'));
    });
  }

}
